<template>
  <el-dialog
    :title="title"
    :visible.sync="isShow"
    width="30%"
    center
    :show-close="false"
    top="38vh"
  >
    <template #title>
      <div class="del-dialog-title">
        <!-- <img src="@/assets/images/warn_orange.png" /><span>{{ title }}</span> -->
         <img src="@/assets/images/info-circle-fill@2x.png" /><span>{{ title }}</span>
      </div>
    </template>
    <span class="del-dialog-content">{{ contentText }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button class="dialog-footer-btn" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "conDialog",
  props: {
    contentText: {
      type: String,
    },
    title: {
      type: String,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    confirm() {
      this.$emit("conform");
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="less" scoped>
.del-dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
  }
  span {
    color: #1d2129;
    font-size: 16px;
    font-weight: 500;
    margin-left: 8px;
  }
}
.del-dialog-content {
  color: #1d2129;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  .el-button {
    width: 60px;
    height: 32px;
    border-radius: 2px;
    background-color: #f2f3f5;
    font-weight: 400;
    font-size: 14px;
    color: #4e5969;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dialog-footer-btn {
    background-color: #165dff;
    color: #ffffff;
  }
}
::v-deep .el-dialog--center .el-dialog__body{
  text-align: center;
}
</style>